import { Component, Input, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { Employee } from '@models/employee/employee.model';

@Component({
    selector: 'app-org-accordion-item',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './org-accordion-item.template.html',
    styleUrls: ['./org-accordion-item.style.scss'],
})
export class OrgAccordionItemComponent {
    @Input() employee: Employee;
    @Input() showName: boolean;
    @Input() showPhoto: boolean;
    @Input() showDepartment: boolean;
    @Input() showPosition: boolean;

    constructor(private element: ElementRef) {}
    onToggle(): void {
        $(this.element.nativeElement).find('.content').toggleClass('active');
    }
}
